import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // 严格受保护：仅当存在 token 时允许访问
  const token = localStorage.getItem('access_token');
  if (token) {
    return <>{children}</>;
  }

  // 无token且后端未放行，跳转登录并保留来源
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;

